import $ from '/js/header/jquery.js';
import { ListViewHelper } from "../../js/tools/common-board/ListViewHelper";

class BoardListManager {
    constructor() {
        this.listViewHelper = new ListViewHelper();
        this.manualChange = false;
        this.board_id = new URLSearchParams(window.location.search).get('board_id');
        this.pageNo = new URLSearchParams(window.location.search).get('page') || 1;
        this.history = window.history;

        this.init();
    }

    init() {
        if (!this.history.enabled) {
            return false;
        }

        // 행 클릭 콜백 설정
        this.listViewHelper.setRowCallback((idx) => this.readGo(idx));

        // History 초기 설정
        this.history.pushState({
            section: 1,
            page_index: this.pageNo
        }, "두인옥션", `?board_id=${this.board_id}&page=${this.pageNo}`);

        // History 이벤트
        this.history.Adapter.bind(window, 'statechange', () => {
            const State = this.history.getState();
            if (this.manualChange) return false;
            this.list(State.data['page_index']);
        });

        // 검색 버튼 이벤트
        this.initSearchEvent();

        // 글쓰기 버튼 이벤트
        this.initWriteEvent();
    }

    initSearchEvent() {
        // 검색 버튼이 있다면 이벤트 연결
        $("#searchBtn").on('click', () => this.list(1));
    }

    initWriteEvent() {
        $("#writeBtn").on('click', () => this.writeGo());
    }

    list(pageNo) {
        if(pageNo) {
            this.pageNo = pageNo;
        }
        // history push
        this.manualChange = true;

        const data = {
            board_id: this.board_id,
            pageNo: this.pageNo,
            dataSize: 20,
            pageSize: 10,
            srch_type: $("#srch_type").val(),
            srch_key_word: $("#srch_key_word").val(),
            mode: 'list'
        }

        $.ajax({
            type: "POST",
            url: "/board/res/Board.php",
            data: data,
            dataType: "JSON",
            success: (data) => {
                const theadHtml = `
                <tr class='h30'>
                    <th class='no-mobile number'>번호</th>
                    <th class='ac'>제목</th>
                    <th class='ac'>작성일</th>
                    <th class='ac no-mobile viewCount'>조회</th>
                </tr>
                `;
                $("#ltThead").html(theadHtml);
                let tbodyHtml = '';
                if (data.totCnt > 0) {
                    tbodyHtml = data.item.map((item) => {
                        //제목
                        var head = (item.step > 0) ? "<img src='/doAdmin/img/btn/reply.gif' alt='답변'> " : "<img src='/doAdmin/img/btn/list_head.gif' alt='목록'> ";
                        var tail_count = (item.tail_count > 0) ? "<span class='f11' style='padding-left:3px'>[" + item.tail_count + "]</span>" : "";
                        var no = (item.noti) ? "<span class='bold'>공지</span>" : item.no;
                        var title_class = item.title_class;

                        return `
                        <tr class='list h35' data-action='readGo' data-idx='${item.idx}'>
                            <td class='ac no-mobile'>${no}</td>
                            <td class='al ${title_class}'>
                                ${head}
                                <span>${item.title}</span>
                                ${tail_count}
                            </td>
                            <td class='ac'>${item.wdate}</td>
                            <td class='ac no-mobile'>${item.read_count}</td>
                        </tr>
                    `;
                    }).join('');
                    // history push
                    $("#paging").show();
                    $("#paging").html(this.listViewHelper.paging(
                        data.totCnt,
                        this.pageNo,
                        (page) => this.list(page), // 콜백 전달
                        20,
                        10
                    ));
                    this.history.pushState({
                        section: 1,
                        page_index: this.pageNo
                    }, "두인옥션", `?board_id=${this.board_id}&page=${this.pageNo}`);
                    this.manualChange = false;
                    // history push
                } else {
                    $("#paging").hide();
                    const emptyHtml = "<tr style='line-height:200px'><td colspan='15' style='text-align:center;font-size:14px;color:#555'>검색 결과가 없습니다.</td></tr>";
                    $("#ltTbody").html(emptyHtml);
                    return;
                }

                $("#ltTbody").html(tbodyHtml);
            },
            error: (xhr, status, error) => {
                console.error('목록 로딩 실패:', error);
            }
        });
    }

    readGo(idx) {
        location.href = `boView.php?board_id=${this.board_id}&idx=${idx}`;
    }

    writeGo() {
        location.href = `boWrite.php?board_id=${this.board_id}`;
    }
}

// 인스턴스 생성
$(() => {
    const boardListManager = new BoardListManager();
    boardListManager.list();

    // data-action readGo 이벤트 바인딩
    $(document).on('click', '[data-action="readGo"]', function () {
        const idx = $(this).data('idx');
        boardListManager.readGo(idx);
    });
});